import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "reactstrap";
import { sortQueue } from "./functions/chat";
import { ConversationItem } from "./ConversationItem";

export function ChatList({ search, chats, showConversation, getChat, activeChat, onConversationClick, messageOperator }) {
  const { t } = useTranslation()

  const obj = useMemo(() => {
    if (search && Array.isArray(search.chats))

      return search.chats.map((id) =>
        chats.find((chat) => chat.conversationId === id)
      )

    if (chats.length) return chats

    return null
  }, [search, chats]);

  const sortedQueue = useMemo(() => sortQueue(obj, getChat), [obj, getChat]);


  const queue = useMemo(() => {
    const queueWithoutTelefone = sortedQueue.filter((chat) => chat.channel !== 'telefone')
    const queueOnlyTelefone = sortedQueue.filter((chat) => chat.channel === 'telefone')

    return [...queueOnlyTelefone, ...queueWithoutTelefone]
  }, [sortedQueue])

  if (queue?.length) return (
    <ul className="list-unstyled chat-list">
      {queue.map((conversation) => {
        if (!showConversation(conversation)) return null

        return (
          <ConversationItem
            key={conversation.conversationId}
            activeChat={activeChat}
            conversation={conversation}
            getChat={getChat}
            onClick={onConversationClick}
            extraClickArgs={{ obj }}
          />
        )
      })}
    </ul>
  )

  if (search?.isSearching)

    return <div className="text-center mt-5">{t("No matching results found")}</div>

  if (messageOperator?.status?.get_messages)

    if (messageOperator?.status?.get_messages?.error?.status) return (
      <div className="text-center mt-5">
        {t(messageOperator.status.get_messages.error.message)}
      </div>
    )

    else return (
      <div className="h-100 text-center pt-4">
        <Spinner animation="border" size="sm" className="spinner" />
      </div>
    )

  return null
}
